import { oz } from '@weft/utils';
import { PRICING_MODELS } from '../../../pricing/pricing-model-schema';
import { TieredSubscriptionPricingConfigurationSchema } from './tiered-subscription-pricing-configuration-schema';

export const TieredSubscriptionPricingSchema = oz.object({
  pricingModel: oz.literal(PRICING_MODELS.TieredSubscription),
  priceConfiguration: TieredSubscriptionPricingConfigurationSchema,
}).openapi('TieredSubscriptionPricing');

export type TieredSubscriptionPricing = oz.infer<typeof TieredSubscriptionPricingSchema>;